import React, { Component } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Tabs,
  Flex,
  WhiteSpace,
  WingBlank,
  Modal,
  Toast,
  Button,
  List,
  Radio,
} from 'antd-mobile'
import QrScanner from 'qr-scanner'
import wx from 'weixin-js-sdk'
import liff from '@line/liff'
import moment from 'moment'
import './index.css'
import { cleanAuth, cleanStorage } from '../../utils/storage'
import T from '../../utils/language'
import qrcodeImg from '../../assets/imgs/code.png'
import closeImg from '../../assets/imgs/close.png'
import refreshImg from '../../assets/imgs/refresh.png'
import Mqttbox from '../../components/mqttBox'
import BatteryItem from '../../components/BatteryItem'
import { isWX, getUrlParms, getSoltStateList } from '../../utils'
import {
  getWxSDK,
  bindImeiUuidCode,
  getUuidInfo,
  getPopUuidInfo,
  popSystemBattery,
  resetSystem,
  movementSystemInfo,
  submitMovementSystemInfo,
  getSystemDetail,
  getSystemTwoDetail,
  getHoleDetailInfo,
  popSystemIndex,
  getDeviceInfoByUuid,
  getDeviceVersionInfoByUuid,
  popupPOSById,
} from '../../apis'
import { wxConfig, config } from '../../config'
import cx from 'classnames'

class Index extends Component {
  state = {
    deviceImei: '', // imei号
    uuid: '', // 绑定页面二维码编号
    popUuid: '', //弹出界面二维码编号
    popCount: 1, // 弹出电池数量
    popInfo: null, // 机柜信息
    systemDetail: null, //弹出机柜详情（1.0）
    systemTwoDetail: null, //弹出机柜详情（2.0）
    detailVisible: false, // 详情弹窗显示
    scannerVisible: false, //  QRCode Scanner Modal
    tabIndex: 0, //tabs选中项
    languageSetting: 'auto', // auto zh_CN en_US ja_JP
    tabItemIndex: 0, //tabs选中项
    holeInfoArray: [], //孔位数组
    screenType: 'hs',
    devicePatternName: '',
    putInAreaName: '',
    deviceOpenAreaList: [], //竖屏投放地区列表
    devicePatternListVOList: [], //竖屏设备类型列表
    putInArea: undefined, //竖屏投放地区
    devicePatternId: undefined, //竖屏设备类型
    oldPatternDevice: false, //是否是竖屏旧设备
    submitBindLoading: false,
    deviceType: 0, // 3:三代机柜 5:四代机柜
    adapterPower: '', //电源适配器功率 或者 电池容量 （户外5口设备才有）都用此字段
    serialPortList: [
      { name: T('单串口'), value: 1 },
      { name: T('双串口'), value: 2 },
    ], //串口模式数组
    serialPortMcuCount: '', //串口总数
    serialPortMode: undefined, //串口模式 1:单串口 2:双串口
    supportStack: undefined, //是否支持堆叠(1:是,2:否)
    supportShipNumList: [], //可选的机芯总数列表
    movementSystemVisible: false, //机芯配置弹窗显示
    movementSerialPortMode: 1, //配置机芯串口 1:单串口 2:双串口
    movementSerialPortMcuCount: '', //配置机芯串口总数
    movementSerialPortInfo: null, //机芯配置信息
    deviceId: '', //设备id
    movementInfoList: [], //机芯数组
    movementDetailsInfo: null, //机芯详情
    prevlist: [],
    nextlist: [],
    movementInfoLose: false, //机芯孔位是否有丢失
    protocolVersion: '', //弹出测试-机柜协议 1.0或者2.0
    bindProtocolVersion: '', //出厂绑定-机柜协议 1.0或者2.0
    devicePowerType: 1, //电源类型 1：电源适配器功率 2：蓄电池容量（出厂绑定模块使用）
    horizontal: false,
    horizontalWidth: '',
    vertical: false,
    verticalWidth: '',
    showPassword: false,
    posSerialNo: '',
    showSlotState: false,
  }

  popBtnStatus = true // 弹出电池按钮是否可点击状态
  apkSignAlias = ''
  userId = window.localStorage.getItem('accountId')
  isTest = window.sessionStorage.getItem('isTest') === '1'
  role = window.localStorage.getItem('role')

  componentDidMount() {
    window.addEventListener('click', (e) => {
      this.updateTime()
    })

    if (isWX()) {
      getWxSDK()
        .then((res) => {
          wx.config({
            appId: wxConfig.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: ['scanQRCode'],
          })
        })
        .catch(() => {
          cleanAuth()
          window.location.reload()
        })
    }

    if (localStorage.getItem('tabIndex')) {
      this.setState({
        tabIndex: Number(localStorage.getItem('tabIndex')),
        popUuid: localStorage.getItem('popUuid'),
      })
    }

    if (localStorage.getItem('language')) {
      this.setState({
        languageSetting: localStorage.getItem('language'),
      })
    }
  }

  updateTime() {
    localStorage.setItem('time', new Date().getTime())
  }

  qrScannerVideoElement = null
  qrScanner = null

  closeQrScanner = () => {
    if (this.qrScanner) {
      this.qrScanner.stop()
      this.qrScanner.destroy()
    }
    this.qrScanner = null
    this.setState({ scannerVisible: false })
  }

  // 开启扫码
  qrcode(method) {
    if (method === 'input') {
      return new Promise((resolve, reject) => {
        Modal.prompt(
          T('手动输入设备号/二维码 URL'),
          T('请输入设备号/完整的 URL'),
          [
            { text: T('取消') },
            {
              text: T('确认'),
              onPress: (value) => {
                resolve(value)
              },
            },
          ],
          'default',
          undefined,
          [T('设备号或https://api.chargespot.cn/')]
        )
      })
    }

    if (liff.isInClient()) {
      return liff.scanCodeV2().then((result) => result.value)
    }

    if (isWX()) {
      if (this.isTest) {
        return Promise.resolve(`w?uuid=${this.state.popUuid}&type=3`)
      }
      return new Promise((resolve, reject) => {
        wx.scanQRCode({
          needResult: 1,
          scanType: ['qrCode'],
          success: (res) => {
            resolve(res.resultStr)
          },
        })
      })
    } else if (this.isTest) {
      // 普通uuid gik2VfmPhVGoUFXzVa5yb3
      // 无屏uuid LEkOcxGmh7eHfzS1Hh5W1, LlMd_BfCgBmwt1KYrmu6G1 Rx_0Cn0_ipeBTroIFM27H2 0ZWHteMQjgaqtnUn8TPir0
      return Promise.resolve('www.xxx.com?uuid=08icvBqhwy_uPa9BuD3g2&type=3')
    } else {
      this.setState({ scannerVisible: true })
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.qrScanner = new QrScanner(
            this.qrScannerVideoElement,
            (result) => {
              resolve(result.data)
              this.closeQrScanner()
            },
            {
              highlightScanRegion: true,
              highlightCodeOutline: true,
            }
          )
          this.qrScanner.start()
        }, 300) // HACK: wait for element ref
      })
    }
  }

  // 绑定页面扫码
  openBindQrcode(qrType) {
    this.qrcode().then((result) => {
      if (qrType === 'adapterPower') {
        if (result.includes(';') || result.includes('；')) {
          const codeString = result.split(/;|；/)[0]
          // 正则表达式：// 检查是否符合xxW（xx为数字，W不区分大小写）或 xx+mAh
          const regex = /^(\d+)(W|mAh)$/i
          if (regex.test(codeString)) {
            this.setState({
              adapterPower: result,
            })
          } else {
            this.setState({
              adapterPower: '',
            })
            Toast.info('请扫码正确的二维码')
          }
        } else {
          this.setState({
            adapterPower: '',
          })
          Toast.info('请扫码正确的二维码')
        }
        return
      }
      let qrValue = getUrlParms(result, qrType)
      let popUuid = getUrlParms(result, 'uuid')

      if (
        result.includes(';') &&
        result.match(/;/g).length >= 2 &&
        !result.includes('deviceImei')
      ) {
        qrValue = result.split(';')[0]
      }

      if (qrType === 'deviceImei') {
        if (!new RegExp('^[0-9|]+$').test(qrValue)) {
          this.setState({
            deviceImei: '',
          })
          Toast.info('IMEI读取异常，请重试')
          return
        }
        this.apkSignAlias = getUrlParms(result, 'apkSignAlias')
      }

      if (qrValue) {
        this.setState({
          [qrType]: qrValue,
        })
        if (qrType === 'uuid') {
          this.handleGetDeviceInfoByUuid(popUuid)
        }
      } else {
        Toast.info(T('您扫描的二维码格式不对'))
      }
    })
  }

  //出厂绑定-根据二维码获取机柜信息
  handleGetDeviceInfoByUuid(popUuid) {
    getDeviceInfoByUuid(popUuid).then((res) => {
      this.setState({
        screenType: res.screenType,
        deviceType: res.type,
        bindProtocolVersion: res.protocolVersion,
        devicePowerType: res.devicePowerType,
      })
      if (res.screenType === 'hs' || res.screenType === 'ns') {
        this.setState({
          devicePatternName: res.devicePatternName,
          putInAreaName: res.putInAreaName,
        })
      }
      if (res.screenType === 'vs') {
        this.setState({
          oldPatternDevice: res.deviceId ? true : false,
          deviceOpenAreaList: res.deviceOpenAreaList || [],
          devicePatternListVOList: res.devicePatternListVOList || [],
          putInArea: res.putInArea
            ? res.putInArea
            : localStorage.getItem('putInArea') || undefined,
          devicePatternId: res.devicePatternId
            ? res.devicePatternId
            : localStorage.getItem('devicePatternId') || undefined,
        })
      }
      if (res.protocolVersion === '2.0') {
        //2.0协议的机柜
        if (
          res.screenType === 'vs' &&
          !res.deviceId &&
          localStorage.getItem('devicePatternId') !== ''
        ) {
          const index =
            document.getElementById('device-type').options.selectedIndex - 1
          this.setState({
            serialPortMode:
              this.state.devicePatternListVOList[index].serialPortMode,
            serialPortMcuCount:
              this.state.devicePatternListVOList[index].serialPortMcuCount,
            adapterPower: '',
          })
        } else {
          this.setState({
            serialPortMode: res.serialPortMode,
            serialPortMcuCount: res.serialPortMcuCount,
            adapterPower: '',
          })
        }
        this.setState({
          supportStack: res.supportStack,
          supportShipNumList: res.supportShipNumList,
        })
      }
    })
  }

  //弹出测试--根据二维码/设备编号获取机柜信息
  handlePopupBatteryGetDeviceInfoByUuid(popUuid) {
    getDeviceVersionInfoByUuid(popUuid).then((res) => {
      this.setState(
        {
          deviceType: res.type,
          popInfo: null,
          deviceId: res.id,
          protocolVersion: res.protocolVersion,
          posSerialNo: res.posSerialNo,
        },
        () => {
          this.getPopInfo()
        }
      )
    })
  }

  // 弹出电池扫码
  openPopQrcode(method) {
    this.qrcode(method).then((result) => {
      const popUuid = getUrlParms(result, 'uuid')
      const pattern = /^\d{6}$/
      const deviceNo = pattern.test(result)
      if (popUuid || deviceNo === true) {
        this.setState({
          popUuid: deviceNo ? result : popUuid,
        })
        this.handlePopupBatteryGetDeviceInfoByUuid(deviceNo ? result : popUuid)
      } else {
        Toast.info(T('请输入正确的设备编号或完整的URL'))
      }
    })
  }

  // 弹出电池输入ID
  promptId() {
    return new Promise((resolve, reject) => {
      Modal.prompt(
        T('手动输入机器编号'),
        T('通常是6位数字'),
        [
          { text: T('取消') },
          {
            text: T('确认'),
            onPress: (value) => {
              resolve(value)
            },
          },
        ],
        'default',
        undefined,
        ['336752']
      )
    })
  }

  openPopId() {
    this.promptId()
      .then((deviceId) => getUuidInfo(deviceId))
      .then((res) => {
        const popUuid = res
        this.setState({ popUuid })
        this.handlePopupBatteryGetDeviceInfoByUuid(popUuid)
      })
  }

  // 获取机柜信息
  getPopInfo() {
    getPopUuidInfo(this.state.deviceId, this.userId).then((res) => {
      const { posSerialNo } = this.state
      this.setState({
        popInfo: { ...res, posSerialNo },
        popCount: res.borrow,
        horizontal: res.deviceSlotRowColumnList[0].slotIndexList.length === 1,
        horizontalWidth:
          res.deviceSlotRowColumnList.length > 9
            ? `${res.deviceSlotRowColumnList.length * 40}px`
            : '100%',
        vertical: res.deviceSlotRowColumnList[0].slotIndexList.length > 1,
        verticalWidth:
          res.deviceSlotRowColumnList.length > 4
            ? `${res.deviceSlotRowColumnList.length.length * 100}px`
            : '100%',
      })
    })
  }

  // type 1为新增 0为减少
  changeCount(type) {
    const { popCount, popInfo } = this.state
    if (!popInfo) {
      return false
    }
    const maxBorrow = popInfo.borrow

    if (type) {
      // 新增 若达到最大值则不增加
      this.setState({
        popCount: popCount === maxBorrow ? popCount : popCount + 1,
      })
    } else {
      // 减少 最小值为1
      this.setState({
        popCount: popCount === 1 ? 1 : popCount - 1,
      })
    }
  }

  // input输入
  handleDeviceImei(e) {
    this.setState({
      deviceImei: e.target.value,
    })
  }

  // 电源适配器功率或者电池容量input输入
  handleDevicePower(e) {
    this.setState({
      adapterPower: e.target.value,
    })
  }

  handleUuid(e) {
    this.setState({
      uuid: e.target.value,
    })
  }

  handlePopUuid(e) {
    this.setState({
      popInfo: null,
      popUuid: e.target.value,
    })
  }

  handleModalSerialPortModeCountDown(e) {
    this.setState({
      movementSerialPortMcuCount: e,
    })
    if (this.state.movementSerialPortMode === 2) {
      //双串口
      if (e % 2 !== 0) {
        //奇数
        this.setState({
          movementSerialPortMcuCount: '',
        })
        Toast.info('双串口只能输入偶数机芯总数')
      }
    }
  }

  handleModalSerialPortModeCount(e) {
    let num = e.target.value.replace(/^(0+)|[^\d]+/g, '')
    if (num > 20) {
      num = 20
    }
    this.setState({
      movementSerialPortMcuCount: num,
    })
  }

  handleSerialPortModeCountDown(e) {
    this.setState({
      serialPortMcuCount: e,
    })
    if (this.state.serialPortMode === 2) {
      //双串口
      if (e % 2 !== 0) {
        //奇数
        Toast.info('双串口只能输入偶数机芯总数')
        this.setState({
          serialPortMcuCount: '',
        })
      }
    }
  }

  handleSerialPortModeCount(e) {
    let num = e.target.value
    if (num > 20) {
      num = 20
    }
    this.setState({
      serialPortMcuCount: num,
    })
  }

  // 绑定机柜
  submitBind = () => {
    const {
      deviceImei,
      uuid,
      devicePatternId,
      putInArea,
      adapterPower,
      serialPortMcuCount,
      serialPortMode,
      bindProtocolVersion,
    } = this.state

    if (deviceImei && uuid) {
      if (bindProtocolVersion === '2.0') {
        //2.0协议
        if (!adapterPower) {
          Toast.info('请先扫码获得信息')
          return
        }
      }

      if (!new RegExp('^[0-9|]+$').test(this.state.deviceImei)) {
        this.setState({
          deviceImei: '',
        })
        Toast.info('IMEI读取异常，请重试')
        return
      }
      let params = {
        deviceImei,
        uuid,
        apkSignAlias: this.apkSignAlias,
        putInArea: '',
        devicePatternId: '',
        adapterPower,
        serialPortMode,
        serialPortMcuCount,
      }

      if (this.state.screenType === 'vs') {
        if (!devicePatternId) {
          Toast.info('请选择设备类型')
          return
        }
        if (!putInArea) {
          Toast.info('请选择投放地区')
          return
        }
        params = {
          deviceImei,
          uuid,
          apkSignAlias: this.apkSignAlias,
          putInArea,
          devicePatternId,
          adapterPower,
          serialPortMode,
          serialPortMcuCount,
        }
      }
      this.setState({
        submitBindLoading: true,
      })
      bindImeiUuidCode(params)
        .then(() => {
          Toast.success(T('绑定成功'))
          this.setState({
            deviceImei: '',
            uuid: '',
            devicePatternName: '',
            putInAreaName: '',
            serialPortMode: undefined,
            serialPortMcuCount: '',
          })
          if (this.state.screenType === 'vs') {
            localStorage.setItem('putInArea', putInArea)
            localStorage.setItem('devicePatternId', devicePatternId)
          }
        })
        .finally(() => {
          this.setState({
            submitBindLoading: false,
          })
        })
    } else {
      Toast.info('请先扫码获得信息')
    }
  }

  //3代机 2.0协议点击查看设备详情
  lookDeviceDetail = () => {
    this.handleDetailModal()
  }

  // 确认弹出电池
  submitPop = () => {
    const { popInfo, popCount } = this.state
    if (!popInfo) {
      Toast.info(T('请先扫码获取机柜信息'))
      return false
    }
    if (!this.popBtnStatus) {
      return false
    }

    Modal.alert(T('提示'), T('确认弹出电池'), [
      {
        text: T('取消'),
      },
      {
        text: T('确认'),
        onPress: () => {
          this.popBtnStatus = false
          const info = popInfo
          popSystemBattery(
            info.deviceSn,
            popCount,
            localStorage.getItem('accountId')
          )
            .then((res) => {
              Toast.success(T('弹出成功'))
              this.getPopInfo()
            })
            .finally(() => {
              this.popBtnStatus = true
            })
        },
      },
    ])
  }

  // 获取1.0协议机柜详情
  getSystemDetail() {
    getSystemDetail(this.state.deviceId).then((res) => {
      this.setState({
        systemDetail: res,
      })
    })
  }

  // 获取2.0协议机柜详情
  getSystemTwoDetail(i) {
    const id = this.state.popInfo.deviceId
    getSystemTwoDetail(id).then((res) => {
      this.setState(
        {
          systemTwoDetail: res,
        },
        () => {
          res.deviceBaseShipListVOList.forEach((item, index) => {
            let itemInfo = {
              title: `机芯${index + 1}`,
            }
            this.state.movementInfoList.push(itemInfo)
          })
          this.getHoleDetailInfo(i)
        }
      )
    })
  }

  // 获取2.0协议机柜孔位详情--注意是孔位详情
  getHoleDetailInfo(i) {
    const { systemTwoDetail, popInfo } = this.state
    const data = {
      deviceId: popInfo.deviceId,
      mcuAddress: systemTwoDetail.deviceBaseShipListVOList[i].mcuAddress,
    }
    getHoleDetailInfo(data).then((res) => {
      this.setState(
        {
          movementDetailsInfo: res,
          holeInfoArray: res.slotList,
        },
        () => {
          const elementInfo = res.slotList.find(
            (slotItem) => slotItem.slotState !== -1
          )
          this.setState({
            movementInfoLose: elementInfo ? true : false,
          })
        }
      )
    })
  }

  // 远程重启设备
  resetSystem() {
    resetSystem(this.state.deviceId).then((res) => {
      if (res.isSuccess) {
        Toast.success('重启成功')
      } else {
        Toast.info('重启失败')
      }
    })
  }

  //获取机芯配置信息
  movementSystemInfo() {
    Toast.loading(T('加载中…'))
    movementSystemInfo(this.state.deviceId).then((res) => {
      Toast.hide()
      this.setState(
        {
          movementSerialPortInfo: res,
          movementSerialPortMode: res.serialPortMode,
          movementSerialPortMcuCount:
            res.serialPortMcuCount === 0 ? '' : res.serialPortMcuCount,
        },
        () => {
          this.setState({
            movementSystemVisible: true,
          })
        }
      )
    })
  }

  //提交机芯配置
  submitMovementConfiguration() {
    if (this.state.movementSerialPortMcuCount === '') {
      Toast.info('请输入串口机芯总数')
      return
    }
    const serialPortMode = document.getElementById('double').checked ? 2 : 1
    Toast.loading(T('加载中…'))

    const params = {
      serialPortMode: serialPortMode,
      serialPortMcuCount: this.state.movementSerialPortMcuCount,
      deviceId: this.state.deviceId,
    }
    submitMovementSystemInfo(params).then((res) => {
      Toast.hide()
      Toast.success(T('操作成功'))
      this.setState({
        movementSystemVisible: false,
      })
    })
  }

  // 弹出电池
  popBattery(index) {
    const { popInfo } = this.state
    const info = popInfo
    popSystemIndex(
      info.deviceSn,
      index,
      localStorage.getItem('accountId')
    ).then((res) => {
      Toast.success(T('弹出成功'))
      this.getPopInfo()
    })
  }

  getHoleState(index) {
    if (index === 0) {
      return '没有移动电源'
    } else if (index === -1) {
      return '机芯故障'
    } else if (index === 1) {
      return '正常'
    } else if (index === 2) {
      return '充电异常'
    } else if (index === 3) {
      return '通讯异常'
    } else if (index === 4) {
      return '弹出失败'
    } else if (index === 8) {
      return '弹出失败'
    } else if (index === 10) {
      return '通讯异常'
    } else {
      return '其他'
    }
  }

  // 详情弹窗状态控制
  handleDetailModal = () => {
    const { protocolVersion, detailVisible, tabItemIndex } = this.state
    if (!detailVisible) {
      //2.0协议
      if (protocolVersion === '2.0') {
        this.getSystemTwoDetail(tabItemIndex)
      } else {
        this.getSystemDetail()
      }
    } else {
      this.setState({
        movementInfoList: [],
      })
    }
    this.setState({
      detailVisible: !detailVisible,
    })
  }

  //有屏查看密码
  handleViewPassword = () => {
    this.setState({
      showPassword: true,
    })
  }

  //前往回收备用电池/新增备用电池
  gotoBatteryPage(type) {
    let { popInfo, tabIndex, popUuid } = this.state
    localStorage.setItem('popUuid', popUuid)
    localStorage.setItem('tabIndex', tabIndex)
    let tempBusinessInfo = {
      businessName: popInfo.businessName,
      businessId: popInfo.businessId,
      pageType: type,
    }
    localStorage.setItem('businessInfo', JSON.stringify(tempBusinessInfo))
    this.props.navigate('/home/battery', { state: tempBusinessInfo })
  }

  //tab change
  onTabClick(tab, index) {
    this.setState({
      tabIndex: Number(index),
    })
    localStorage.removeItem('popUuid')
    localStorage.removeItem('tabIndex')
  }

  //机芯tab change
  onMovementTabClick(tab, index) {
    this.setState(
      {
        tabItemIndex: Number(index),
      },
      () => {
        this.getHoleDetailInfo(index)
      }
    )
  }

  //弹出POS机
  popupPOS() {
    Toast.loading(T('弹出中…'))
    popupPOSById(this.state.deviceId)
      .then(() => {
        Toast.success(T('弹出成功'))
      })
      .catch((e) => {
        Toast.fail(e)
      })
  }

  render() {
    const tabTitles = [
      { title: T('出厂绑定'), key: 'bind' },
      { title: T('弹出测试'), key: 'eject' },
      { title: T('设置'), key: 'setting' },
    ].filter((tab) => {
      if (
        (this.role === 'imei' || this.role === 'imei_eu') &&
        tab.key === 'bind'
      )
        return false
      return true
    })

    const {
      detailVisible,
      scannerVisible,
      uuid,
      deviceImei,
      popCount,
      popInfo,
      popUuid,
      systemDetail,
      systemTwoDetail,
      tabIndex,
      languageSetting,
      tabItemIndex,
      holeInfoArray,
      screenType,
      deviceType,
      adapterPower,
      movementSystemVisible,
      movementSerialPortInfo,
      movementInfoLose,
      protocolVersion,
      bindProtocolVersion,
      devicePatternName,
      devicePowerType,
      oldPatternDevice,
      horizontal,
      horizontalWidth,
      vertical,
      verticalWidth,
      showPassword,
      showSlotState,
    } = this.state

    const holesListWidth = horizontal
      ? horizontalWidth
      : vertical
      ? verticalWidth
      : '100%'

    return (
      <div className="container">
        <Modal
          visible={movementSystemVisible}
          transparent
          style={{ width: 300 }}
          maskClosable={true}
          closable
          onClose={() => {
            this.setState({
              movementSystemVisible: false,
            })
          }}
          title={T('机芯配置')}
          footer={[
            {
              text: T('提交'),
              onPress: () => {
                this.submitMovementConfiguration()
              },
            },
          ]}
        >
          <div style={{ height: 120 }}>
            <div style={{ display: 'flex' }}>
              <div>{T('串口模式：')}</div>
              <input
                type="radio"
                id="singular"
                name="movement"
                value={1}
                onClick={() => {
                  this.setState({
                    movementSerialPortMode: 1,
                    movementSerialPortMcuCount: '',
                  })
                }}
                checked={this.state.movementSerialPortMode === 1}
              />
              {T('单串口')}
              <input
                style={{ marginLeft: 10 }}
                value={2}
                type="radio"
                id="double"
                name="movement"
                onClick={() => {
                  this.setState({
                    movementSerialPortMode: 2,
                    movementSerialPortMcuCount: '',
                  })
                }}
                checked={this.state.movementSerialPortMode === 2}
              />
              {T('双串口')}
            </div>

            <div style={{ display: 'flex', marginTop: 10 }}>
              <div style={{ width: 120, textAlign: 'left' }}>
                {T('串口机芯总数：')}
              </div>
              <div className="serialport-input">
                <input
                  οninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  type="text"
                  required
                  value={this.state.movementSerialPortMcuCount}
                  placeholder={T('请输入')}
                  onChange={this.handleModalSerialPortModeCount.bind(this)}
                  onBlur={(e) => {
                    this.handleModalSerialPortModeCountDown(e.target.value)
                  }}
                />
              </div>
            </div>
            {movementSerialPortInfo && (
              <div style={{ textAlign: 'left', marginTop: 10 }}>
                {T('更新时间：')}
                {movementSerialPortInfo.modifyTime
                  ? moment(Number(movementSerialPortInfo.modifyTime)).format(
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  : ''}
              </div>
            )}
            {movementSerialPortInfo && (
              <div style={{ textAlign: 'left', marginTop: 10 }}>
                {T('结果：')}
                {movementSerialPortInfo.state === 0
                  ? T('发送中')
                  : movementSerialPortInfo.state === 1
                  ? T('成功')
                  : T('失败')}
              </div>
            )}
          </div>
        </Modal>

        <Tabs
          tabs={tabTitles}
          useOnPan={false}
          swipeable={false}
          page={tabIndex}
          onTabClick={this.onTabClick.bind(this)}
        >
          {this.role !== 'imei' || this.role !== 'imei_eu' ? (
            <div key="bind">
              <WhiteSpace size="lg" />
              <WingBlank size="lg">
                <ul className="system">
                  <li>
                    <p>{T('扫码录入IMEI号')}</p>
                    <WhiteSpace size="md" />
                    <Flex justify="between" alignContent="center">
                      <div className="code-input">
                        <input
                          type="text"
                          value={deviceImei}
                          onChange={this.handleDeviceImei.bind(this)}
                        />
                      </div>
                      <div
                        className="photo"
                        onClick={this.openBindQrcode.bind(this, 'deviceImei')}
                      >
                        <img src={qrcodeImg} alt="扫码" />
                      </div>
                    </Flex>
                  </li>
                  <WhiteSpace size="lg" />
                  <li>
                    <p>{T('扫码录入二维码编号')}</p>
                    <WhiteSpace size="md" />
                    <Flex justify="between" alignContent="center">
                      <div className="code-input">
                        <input
                          type="text"
                          value={uuid}
                          onChange={this.handleUuid.bind(this)}
                          onBlur={(e) => {
                            if (!e.target.value) return
                            this.handleGetDeviceInfoByUuid(e.target.value)
                          }}
                        />
                      </div>
                      <div
                        className="photo"
                        onClick={this.openBindQrcode.bind(this, 'uuid')}
                      >
                        <img src={qrcodeImg} alt="扫码" />
                      </div>
                    </Flex>
                  </li>
                  {/* 出厂绑定模块-2.0协议的机柜 */}
                  {bindProtocolVersion === '2.0' && (
                    <dev>
                      <li>
                        <WhiteSpace size="lg" />
                        {devicePowerType === 2 ? (
                          <p>{T('电池容量')}</p>
                        ) : (
                          <p>{T('电源适配器功率')}</p>
                        )}

                        <WhiteSpace size="md" />
                        <Flex justify="between" alignContent="center">
                          <div className="code-input">
                            <input
                              disabled={true}
                              type="text"
                              value={adapterPower}
                              onChange={this.handleDevicePower.bind(this)}
                            />
                          </div>
                          <div
                            className="photo"
                            onClick={this.openBindQrcode.bind(
                              this,
                              'adapterPower'
                            )}
                          >
                            <img src={qrcodeImg} alt="扫码" />
                          </div>
                        </Flex>
                      </li>

                      <li>
                        <WhiteSpace size="lg" />
                        <p>{T('串口模式')}</p>
                        <WhiteSpace size="md" />
                        <Flex justify="between" alignContent="center">
                          <div className="select-wrapper">
                            <select
                              className="device-type-new-dis"
                              disabled
                              value={this.state.serialPortMode}
                              onChange={(e) => {
                                this.setState({
                                  serialPortMode: e.target.value,
                                  serialPortMcuCount: '',
                                })
                              }}
                            >
                              <option value={''} style={{ display: 'none' }}>
                                {T('请选择')}
                              </option>
                              {this.state.serialPortList.map((item) => {
                                return (
                                  <option value={item.value} key={item.value}>
                                    {item.name}
                                  </option>
                                )
                              })}
                            </select>
                          </div>
                        </Flex>
                      </li>

                      {/* 非堆叠机 */}
                      {this.state.supportStack === 2 && (
                        <li>
                          <WhiteSpace size="lg" />
                          <p>{T('串口机芯总数')}</p>
                          <WhiteSpace size="md" />
                          <Flex justify="between" alignContent="center">
                            <div className="code-input">
                              <input
                                οninput="value=value.replace(/^(0+)|[^\d.]/g,'')"
                                type="number"
                                disabled
                                required
                                value={this.state.serialPortMcuCount}
                                placeholder={T('请输入')}
                                onChange={this.handleSerialPortModeCount.bind(
                                  this
                                )}
                                onBlur={(e) => {
                                  this.handleSerialPortModeCountDown(
                                    e.target.value
                                  )
                                }}
                              />
                            </div>
                          </Flex>
                        </li>
                      )}

                      {/* 堆叠机 */}
                      {this.state.supportStack === 1 && (
                        <li>
                          <WhiteSpace size="lg" />
                          <p>{T('串口机芯总数')}</p>
                          <WhiteSpace size="md" />
                          <Flex justify="between" alignContent="center">
                            <div className="select-wrapper">
                              <select
                                className="device-type-new"
                                value={this.state.serialPortMcuCount}
                                onChange={(e) => {
                                  this.setState({
                                    serialPortMcuCount: e.target.value,
                                  })
                                }}
                              >
                                {this.state.supportShipNumList.map((item) => (
                                  <option value={item} key={item}>
                                    {item}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Flex>
                        </li>
                      )}
                    </dev>
                  )}

                  {/* 横屏和无屏扫码后也要展示设备类型和投放地区 */}
                  {(screenType === 'hs' || screenType === 'ns') && uuid && (
                    <li>
                      <WhiteSpace size="lg" />
                      <p>{T('设备类型')}</p>
                      <WhiteSpace size="md" />
                      <Flex justify="between" alignContent="center">
                        <div className="code-input">
                          <input
                            disabled={true}
                            type="text"
                            value={devicePatternName}
                          />
                        </div>
                      </Flex>
                    </li>
                  )}

                  {/* 横屏和无屏扫码后也要展示设备类型和投放地区 */}
                  {(screenType === 'hs' || screenType === 'ns') && uuid && (
                    <li>
                      <WhiteSpace size="lg" />
                      <p>{T('投放地区')}</p>
                      <WhiteSpace size="md" />
                      <Flex justify="between" alignContent="center">
                        <div className="code-input">
                          <input
                            disabled={true}
                            type="text"
                            value={this.state.putInAreaName}
                          />
                        </div>
                      </Flex>
                    </li>
                  )}

                  {/* 竖屏展示设备类型和投放地区 需要选择 */}
                  {screenType === 'vs' && uuid && (
                    <li>
                      <WhiteSpace size="lg" />
                      <p>{T('设备类型')}</p>
                      <WhiteSpace size="md" />
                      <Flex justify="between" alignContent="center">
                        <select
                          disabled={oldPatternDevice}
                          id="device-type"
                          className="device-type"
                          value={this.state.devicePatternId}
                          onChange={(e) => {
                            const index =
                              document.getElementById('device-type').options
                                .selectedIndex - 1
                            this.setState({
                              devicePatternId: e.target.value,
                              serialPortMode:
                                this.state.devicePatternListVOList[index]
                                  .serialPortMode,
                              serialPortMcuCount:
                                this.state.devicePatternListVOList[index]
                                  .serialPortMcuCount,
                            })
                          }}
                        >
                          <option value={''} style={{ display: 'none' }}>
                            {T('请选择')}
                          </option>
                          {this.state.devicePatternListVOList.map((item) => {
                            return (
                              <option value={item.id} key={item.id}>
                                {item.patternName}
                              </option>
                            )
                          })}
                        </select>
                      </Flex>
                    </li>
                  )}

                  {screenType === 'vs' && uuid && (
                    <li>
                      <WhiteSpace size="lg" />
                      <p>{T('投放地区')}</p>
                      <WhiteSpace size="md" />
                      <Flex justify="between" alignContent="center">
                        <select
                          disabled={oldPatternDevice}
                          className="device-type"
                          value={this.state.putInArea}
                          onChange={(e) => {
                            this.setState({
                              putInArea: e.target.value,
                            })
                          }}
                        >
                          <option value={''} style={{ display: 'none' }}>
                            {T('请选择')}
                          </option>
                          {this.state.deviceOpenAreaList.map((item) => {
                            return (
                              <option value={item.id} key={item.id}>
                                {item.name}
                              </option>
                            )
                          })}
                        </select>
                      </Flex>
                    </li>
                  )}
                </ul>
              </WingBlank>
              <WhiteSpace size="lg" />

              <div className="btn mar4">
                <WhiteSpace size="lg" />
                <button
                  type="button"
                  className="active"
                  disabled={this.state.submitBindLoading}
                  onClick={this.submitBind}
                >
                  {T('绑定')}
                </button>
              </div>
            </div>
          ) : (
            <div key="bind"></div>
          )}

          <div key="eject" className="sub-container">
            <div className="pt-f2"></div>
            <Flex
              justify="between"
              alignContent="center"
              className="pad15 bor1 fff"
            >
              {this.isTest ? (
                <input
                  type="text"
                  value={popUuid}
                  onChange={this.handlePopUuid.bind(this)}
                />
              ) : (
                <p>{T('扫描机身二维码')}</p>
              )}
              <Flex>
                <div className="photo" onClick={this.openPopQrcode.bind(this)}>
                  <img src={qrcodeImg} alt="扫码" />
                </div>
                <div
                  className="qr-type-button"
                  onClick={this.openPopQrcode.bind(this, 'input')}
                >
                  {this.role !== 'imei_eu' && (
                    <Button size="small">{T('URL')}</Button>
                  )}
                </div>

                {this.role === 'imei' && (
                  <div
                    className="qr-type-button"
                    onClick={this.openPopId.bind(this)}
                  >
                    <Button size="small">{T('ID')}</Button>
                  </div>
                )}
              </Flex>
            </Flex>

            {/* 有屏、无屏机柜信息 */}
            {popInfo && (
              <Mqttbox
                mqttInfo={popInfo}
                deviceType={deviceType}
                resetSystem={this.resetSystem.bind(this)}
                handleDetail={this.handleDetailModal}
                handleViewPassword={this.handleViewPassword}
                movementSystem={this.movementSystemInfo.bind(this)}
                popupPOS={this.popupPOS.bind(this)}
              />
            )}

            <div className="pt-f2"></div>

            {popInfo && (
              <Flex
                justify="between"
                alignContent="center"
                className="pop bor1"
              >
                <span className="f16">{T('SN号弹电')}</span>
                <Flex justify="center" alignContent="center">
                  <button
                    type="button"
                    className="btn-handler"
                    onClick={this.changeCount.bind(this, 0)}
                  >
                    -
                  </button>
                  <div className="btn-handler" style={{ margin: '0 10px' }}>
                    {popCount}
                  </div>
                  <button
                    type="button"
                    className="btn-handler"
                    onClick={this.changeCount.bind(this, 1)}
                  >
                    +
                  </button>
                </Flex>
                <button
                  type="button"
                  className="pop-btn f16"
                  onClick={this.submitPop.bind(this)}
                >
                  {T('批量弹出')}
                </button>
              </Flex>
            )}

            {/* 孔位弹电 */}
            {popInfo && (
              <div className="pad15 bat-list">
                <div className="popBg">
                  <h3 className="popTitle">
                    <div className="popTitleText">{T('孔位弹电')} </div>
                    <sapn
                      className="stateTips"
                      onClick={() => {
                        this.setState({
                          showSlotState: true,
                        })
                      }}
                    >
                      ?
                    </sapn>
                  </h3>
                  <div
                    className={cx(
                      popInfo &&
                        (popInfo.screenType === 'ns' ||
                          protocolVersion === '1.0')
                        ? 'popBg-RightView'
                        : 'popBg-View'
                    )}
                  >
                    {popInfo && (
                      <div className="refreshBg">
                        <img
                          src={refreshImg}
                          alt="refresh"
                          className="refresh"
                          onClick={() => {
                            this.getPopInfo()
                          }}
                        />
                        <button
                          type="button"
                          style={{ color: '#1dc0e6', fontSize: 13 }}
                          onClick={() => {
                            this.getPopInfo()
                          }}
                        >
                          {`${T(`刷新`)}`}
                        </button>
                      </div>
                    )}
                    {/* 2.0协议并且是有屏幕的设备 */}
                    {protocolVersion === '2.0' &&
                      popInfo &&
                      popInfo.screenType !== 'ns' &&
                      this.role !== 'imei_eu' && (
                        <button
                          type="button"
                          style={{ color: '#1dc0e6', fontSize: 13 }}
                          onClick={this.lookDeviceDetail.bind(this)}
                        >
                          {`${T(`设备详情`)} >>>`}
                        </button>
                      )}
                  </div>
                </div>

                {popInfo && popInfo.deviceSlotRowColumnList.length > 0 && (
                  <div style={{ overflow: 'scroll' }}>
                    <Flex
                      justify="center"
                      style={{
                        width: `${holesListWidth}px`,
                      }}
                    >
                      {popInfo.deviceSlotRowColumnList.map((item) => {
                        return (
                          <ul
                            className="pop-flex"
                            key={item.column}
                            style={{
                              width: vertical ? '100px' : '40px',
                              height: vertical
                                ? `${
                                    popInfo.deviceSlotRowColumnList[0]
                                      .slotIndexList.length * 50
                                  }px`
                                : `${
                                    popInfo.deviceSlotRowColumnList[0]
                                      .slotIndexList.length * 100
                                  }px`,
                            }}
                          >
                            {item.slotIndexList.map((v, i) => {
                              return (
                                <BatteryItem
                                  className={cx(
                                    horizontal ? 'horizontal' : 'vertical'
                                  )}
                                  key={new Date().getTime() + i}
                                  battery={v}
                                  normalPower={popInfo.normalPower}
                                  lowPower={popInfo.lowPower}
                                  isHorizontal={horizontal}
                                  onClick={this.popBattery.bind(this, v.index)}
                                />
                              )
                            })}
                          </ul>
                        )
                      })}
                    </Flex>
                  </div>
                )}
              </div>
            )}

            {/* QR Code Modal */}
            <Modal
              title={
                <div>
                  {T('扫描二维码')}
                  <br />
                  <small>{T('很难扫描的情况下推荐使用微信操作')}</small>
                </div>
              }
              popup
              animationType="slide-up"
              visible={scannerVisible}
              onClose={this.closeQrScanner}
            >
              <video
                className="qr-video"
                ref={(element) => {
                  this.qrScannerVideoElement = element
                }}
              />
            </Modal>

            {popInfo && (
              <Modal
                className="passwordModal"
                visible={showPassword}
                title={T('APK后台密码')}
                onClose={() =>
                  this.setState({
                    showPassword: false,
                  })
                }
              >
                <div className="passwordModal-tips">
                  {T('注意：密码每日会重置更新')}
                </div>
                <div>
                  {T('设备：')}
                  {popInfo.deviceNo}
                </div>
                <div>
                  {T('密码：')}
                  {popInfo.posKey}
                </div>
                <button
                  className="passwordModal-button"
                  onClick={() =>
                    this.setState({
                      showPassword: false,
                    })
                  }
                >
                  {T('确定')}
                </button>
              </Modal>
            )}

            {/* 详情弹窗 */}
            <Modal
              popup
              visible={detailVisible}
              onClose={this.handleDetailModal}
              animationType="slide-up"
            >
              <div className="detail-container">
                <img
                  src={closeImg}
                  alt="close"
                  className="close"
                  onClick={this.handleDetailModal}
                />
                {/* //1.0协议的无屏设备才有设备详情，而设备详情里面 无屏设备显示S-MCU */}
                <h3 className="detail-title">{T('设备详情')}</h3>
                {(systemDetail || systemTwoDetail) && (
                  <>
                    <div className="tip-line">
                      <p>
                        {' '}
                        {`${T('更新时间：')}${
                          protocolVersion === '2.0'
                            ? moment(
                                Number(systemTwoDetail.heartbeatModifyTime)
                              ).format('YYYY-MM-DD HH:mm:ss')
                            : systemDetail.smcu.updateTime
                        }`}
                      </p>
                    </div>

                    {(protocolVersion === '1.0' || protocolVersion === '') && (
                      <div className="detail-content">
                        <div className="c-box">
                          <p>
                            S-MCU: {systemDetail.smcu.hwVersion}/
                            {systemDetail.smcu.osVersion}
                          </p>
                        </div>
                        {systemDetail.pinboard &&
                          systemDetail.powerCount === 20 && (
                            <div className="c-box">
                              <p>
                                {T('转接板MCU:')}{' '}
                                {systemDetail.pinboard.pinHwVersion}/
                                {systemDetail.pinboard.pinOsVersion}
                              </p>
                            </div>
                          )}
                        {systemDetail.chipList.map((chipItem, chipIndex) => {
                          return (
                            <div
                              className="c-box"
                              key={new Date().getTime() + chipIndex}
                            >
                              <p>
                                {T('机芯MCU')}
                                {chipIndex + 1}:{chipItem.hwVersion}/
                                {chipItem.osVersion}
                              </p>
                              <ul>
                                {chipItem.powerList.map((pi, powerIndex) => {
                                  return (
                                    <li key={new Date().getTime() + powerIndex}>
                                      {pi.powerNo
                                        ? `${pi.index}/${pi.powerNo}: ${pi.hwVersion}/${pi.osVersion}, 温度${pi.temperature}/电压${pi.voltage}/电流${pi.current}`
                                        : `${pi.index}:`}
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          )
                        })}
                      </div>
                    )}
                    {protocolVersion === '2.0' && (
                      <div className="detail-content">
                        <div className="c-box">
                          <p>
                            {/* //设备种类（1：安卓机柜，3：无屏机柜） */}
                            {systemTwoDetail.deviceSpecies === '1'
                              ? `${T('APK版本:')} ${systemTwoDetail.apkVersion}`
                              : `S-MCU: ${systemTwoDetail.hdVersion}/
                            ${systemTwoDetail.osVersion}`}
                          </p>
                        </div>
                        <Tabs
                          tabs={this.state.movementInfoList}
                          page={tabItemIndex}
                          onTabClick={this.onMovementTabClick.bind(this)}
                        ></Tabs>

                        <ul className="ul_list">
                          {this.state.movementDetailsInfo && (
                            <div className="version_title">{`${T(
                              '软/硬件版本号：'
                            )}V${
                              this.state.movementDetailsInfo.softwareVersion
                            }/V${
                              this.state.movementDetailsInfo.hardwareVersion
                            }  电池数：${
                              this.state.movementDetailsInfo.slotCount
                            }`}</div>
                          )}
                          {movementInfoLose &&
                            holeInfoArray.map((item, i) => {
                              return (
                                <li key={i}>
                                  <p className="hold_title">
                                    {`${T('孔位')}` +
                                      item.slot +
                                      `${T('状态')}`}
                                  </p>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('孔位充电情况：')}
                                      {item.slotChargeState === 1
                                        ? T('孔位正在充电')
                                        : T('孔位未充电')}
                                    </div>
                                    <div className="description_text">
                                      {T('通讯类型：')}
                                      {item.communicationTypeState === 1
                                        ? T('红外通讯')
                                        : T('串口通讯')}
                                    </div>
                                  </div>

                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('通讯情况：')}
                                      {item.communicationSituationState === 1
                                        ? T('有电池无数据')
                                        : T('有电池有数据')}
                                    </div>
                                    <div className="description_text">
                                      {T('行程开关：')}
                                      {item.travelSwitchState === 1
                                        ? T('开关已触发')
                                        : T('开关未触发')}
                                    </div>
                                  </div>

                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('电机开关：')}
                                      {item.motorSwitchState === 1
                                        ? T('开关已触发')
                                        : T('开关未触发')}
                                    </div>
                                    <div className="description_text">
                                      {T('串口通讯情况：')}
                                      {item.serialCommunicationState === 1
                                        ? T('异常')
                                        : T('正常')}
                                    </div>
                                  </div>

                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('红外通讯情况：')}
                                      {item.infraredCommunicationState === 1
                                        ? T('异常')
                                        : T('正常')}
                                    </div>
                                    <div className="description_text">
                                      {T('电池弹出情况：')}
                                      {item.batteryEjectionState === 1
                                        ? T('弹出异常')
                                        : T('弹出正常')}
                                    </div>
                                  </div>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('电源输出电压：')}
                                      {item.chargingVoltage}V
                                    </div>
                                  </div>

                                  <p className="hold_title">{T('电池信息')}</p>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('SN号：')}
                                      {item.powerNo}
                                    </div>
                                    <div className="description_text">
                                      {T('状态：')}
                                      {this.getHoleState(item.slotState)}
                                    </div>
                                  </div>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('放电次数：')}
                                      {item.dischargeCount}
                                    </div>
                                    <div className="description_text">
                                      {T('电量：')}
                                      {item.power}
                                    </div>
                                  </div>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('温度：')}
                                      {item.temperature}
                                    </div>
                                    <div className="description_text">
                                      {T('电池电压：')}
                                      {item.dischargeVoltage}
                                    </div>
                                  </div>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('充电电流：')}
                                      {item.chargingCurrent}
                                    </div>
                                    <div className="description_text">
                                      {T('计算宝容量：')}
                                      {item.capacity}
                                    </div>
                                  </div>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('硬件版本号：')}
                                      {item.hardwareVersion}
                                    </div>
                                    <div className="description_text">
                                      {T('软件版本号：')}
                                      {item.softwareVersion}
                                    </div>
                                  </div>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('开始充电电量：')}
                                      {item.startChargingPower}
                                    </div>
                                    <div className="description_text">
                                      {T('结束充电电量：')}
                                      {item.endChargingPower}
                                    </div>
                                  </div>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('宝上报容量：')}
                                      {item.reportCapacity}
                                    </div>
                                    <div className="description_text">
                                      {T('宝状态码：')}
                                      {item.errorCode === 2 ? '休眠' : '空闲'}
                                    </div>
                                  </div>
                                  <div className="description_box">
                                    <div className="description_timeText">
                                      {T('归还时间：')}
                                      {item.returnTime &&
                                      item.returnTime !== '0'
                                        ? moment(
                                            Number(item.returnTime)
                                          ).format('YYYY-MM-DD HH:mm:ss')
                                        : ''}
                                    </div>
                                  </div>

                                  <p className="hold_title">{T('区域码')}</p>
                                  <div className="description_box">
                                    <div className="description_text">
                                      {T('线材类型：')}
                                      {item.powerNo
                                        ? item.wireType === 1
                                          ? T('3根线')
                                          : T('2根线')
                                        : ''}
                                    </div>
                                    <div className="description_text">
                                      {T('PB类型：')}
                                      {item.supplierCode}
                                    </div>
                                  </div>
                                  <div className="description_box">
                                    <div className="description_timeText">
                                      {T('生产日期：')}
                                      {item.productionDate}
                                    </div>
                                  </div>

                                  {(item.chargingBankTemperatureAlarmState ===
                                    1 ||
                                    item.magazineEventAlarmState === 1 ||
                                    item.warningOfAbnormalVChargingState ===
                                      1 ||
                                    item.coreBoardRestartWarningState ===
                                      1) && (
                                    <p className="hold_title">
                                      {T('仓道警告位')}
                                    </p>
                                  )}
                                  <div className="tag_bg">
                                    {item.chargingBankTemperatureAlarmState ===
                                      1 && (
                                      <div className="tag_item">
                                        {T('充电宝温度警告')}
                                      </div>
                                    )}
                                    {item.magazineEventAlarmState === 1 && (
                                      <div className="tag_item">
                                        {T('弹仓事件警告')}
                                      </div>
                                    )}
                                    {item.warningOfAbnormalVChargingState ===
                                      1 && (
                                      <div className="tag_item">
                                        {T('5V充电异常警告')}
                                      </div>
                                    )}
                                    {item.coreBoardRestartWarningState ===
                                      1 && (
                                      <div className="tag_item">
                                        {T('机芯板重启警告')}
                                      </div>
                                    )}
                                  </div>

                                  {(item.treasureBorrowingFailureState === 1 ||
                                    item.solenoidValveFaultState === 1 ||
                                    item.ejectorFailureState === 1 ||
                                    item.infraredFaultState === 1 ||
                                    item.powerBankFailureState === 1 ||
                                    item.inPositionSwitchFaultState === 1 ||
                                    item.inPositionSwitchFaultTwoState ===
                                      1) && (
                                    <p className="hold_title">
                                      {T('仓道错误位')}
                                    </p>
                                  )}
                                  <div className="tag_bg">
                                    {item.treasureBorrowingFailureState ===
                                      1 && (
                                      <div className="tag_item">
                                        {T('借宝故障')}
                                      </div>
                                    )}
                                    {item.solenoidValveFaultState === 1 && (
                                      <div className="tag_item">
                                        {T('电磁阀故障')}
                                      </div>
                                    )}
                                    {item.ejectorFailureState === 1 && (
                                      <div className="tag_item">
                                        {T('顶针故障')}
                                      </div>
                                    )}
                                    {item.infraredFaultState === 1 && (
                                      <div className="tag_item">
                                        {T('红外故障')}
                                      </div>
                                    )}
                                    {item.powerBankFailureState === 1 && (
                                      <div className="tag_item">
                                        {T('充电宝故障')}
                                      </div>
                                    )}
                                    {item.inPositionSwitchFaultState === 1 && (
                                      <div className="tag_item">
                                        {T('到位1开关故障')}
                                      </div>
                                    )}
                                    {item.inPositionSwitchFaultTwoState ===
                                      1 && (
                                      <div className="tag_item">
                                        {T('到位2开关故障')}
                                      </div>
                                    )}
                                  </div>
                                </li>
                              )
                            })}
                          {movementInfoLose === false && (
                            <div className="version_title">
                              {T('机芯异常，暂无数据')}
                            </div>
                          )}
                        </ul>
                      </div>
                    )}
                  </>
                )}
              </div>
            </Modal>

            <Modal
              className="slotStateModal"
              visible={showSlotState}
              closable
              title={T('孔位说明')}
              onClose={() =>
                this.setState({
                  showSlotState: false,
                })
              }
            >
              <div className="slotStateList">
                {getSoltStateList().map((item, index) => {
                  return (
                    <div className="slotStateItem" key={index}>
                      <div
                        className="colorBox"
                        style={{ backgroundColor: item.color }}
                      ></div>
                      <div className="stateName">{item.name}</div>
                    </div>
                  )
                })}
              </div>
            </Modal>
          </div>

          <div key="setting">
            <List renderHeader={() => T('语言')}>
              <Radio.RadioItem
                checked={languageSetting === 'auto'}
                onChange={() => {
                  localStorage.removeItem('language')
                  window.location.reload()
                }}
              >
                {T('自动')}
              </Radio.RadioItem>
              <Radio.RadioItem
                checked={languageSetting === 'zh_CN'}
                onChange={() => {
                  localStorage.setItem('language', 'zh_CN')
                  window.location.reload()
                }}
              >
                简体中文
              </Radio.RadioItem>
              <Radio.RadioItem
                checked={languageSetting === 'en_US'}
                onChange={() => {
                  localStorage.setItem('language', 'en_US')
                  window.location.reload()
                }}
              >
                English
              </Radio.RadioItem>
              <Radio.RadioItem
                checked={languageSetting === 'ja_JP'}
                onChange={() => {
                  localStorage.setItem('language', 'ja_JP')
                  window.location.reload()
                }}
              >
                日本語
              </Radio.RadioItem>
            </List>
            <List renderHeader={T('开发工具')}>
              {config.Terminal !== 'BIND_ANDROID_EU' && (
                <Button
                  onClick={() => {
                    localStorage.setItem(
                      'CHARGESPOT::devtool',
                      JSON.stringify({ data: 'enable' })
                    )
                    window.location.reload()
                  }}
                >
                  {T('命令行')}
                </Button>
              )}

              <Button
                onClick={() => {
                  cleanStorage()
                  window.location.reload()
                }}
              >
                {T('清除数据')}
              </Button>
            </List>
          </div>
        </Tabs>
      </div>
    )
  }
}

export default function IndexPage() {
  const navigate = useNavigate()
  return <Index navigate={navigate} />
}
